import { useMutation, useQueryClient } from 'react-query';
import { deactivateTeamMember } from 'resources/user/workflows/deactivateTeamMember';


export default function useDeactivateTeamMember(queryOptions) {
  const queryClient = useQueryClient();

  return useMutation(
    (requestData) => deactivateTeamMember(requestData),
    {
      ...queryOptions,
      onSuccess: async (response) => {
        if (!response || response.isBadRequest) {
          return null;
        }

        queryClient.invalidateQueries(['users.userById', response.id]);
        queryClient.invalidateQueries(['users.companyUsers', response.company_id]);
        queryClient.invalidateQueries(['users.teamMembers', response.company_id]);
        queryClient.invalidateQueries(['users.getAgents', response.company_id]);
        queryClient.invalidateQueries(['users.getAdminsAndCoordinators', response.company_id]);

        queryOptions?.onSuccess?.();

        return response;
      },
    },
  );
}
